import { createLazyComponent, LazyModule, type LazyComponent } from "owa-bundling";
import type * as lazyIndex from "./lazyIndex";
import type { HeaderButtonSizingProps } from "./HeaderButtonSizing";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "HeaderButtonSizing" */ "./lazyIndex"), { name: "HeaderButtonSizing" });

export const LazyHeaderButtonSizing: LazyComponent<HeaderButtonSizingProps, unknown, void> = createLazyComponent(lazyModule, module => module.HeaderButtonSizing);
